import { render, staticRenderFns } from "./DocumentStatusNotUploadModal.vue?vue&type=template&id=44c9faf9&"
import script from "./DocumentStatusNotUploadModal.vue?vue&type=script&lang=js&"
export * from "./DocumentStatusNotUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStatusNotUploadModal.vue?vue&type=style&index=0&id=44c9faf9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports